export const registration: object = {
  registration: {
    heading: 'Create a Company Account',
    headingB2I: 'Persönliche Daten',
    subheading: 'Please provide the following information about your company or\n organization.',
    subheadingB2I: 'Bitte füllen Sie die folgenden Felder aus.',
    headingAddress: 'Adresse',
    headingName: 'Name',
    headingSelectCompany: 'Select a Company / Organization',
    subheadingSelectCompany: 'The selected company will be the business entity associated to your SAP Store account.',
    backButton: 'Back',
    searchPlaceholder: 'Search',
    backToSolutionPage: 'Back to Solution Page',
    newCompany: {
      createNew1: 'This information is defined by your company domain administrators.',
      createNew2: 'Don\'t see your company? Please check with the super administrator or ',
      createNew3: 'create new.'
    },
    newCompanyAddress: {
      heading: 'Create a Company Address',
      subheading: 'Please provide the following information about your company or\n organization. We use this information for billing purposes.'
    },
    customerName: {
      heading: 'Account Details',
      subheading: 'Please provide the following information.',
      addingCompanyDisclaimer: 'Adding an organization helps us determine whether your organization has any pre-existing contracts which may affect this purchase.'
    },
    addressSelection: {
      heading: 'Select an Address',
      subheading: 'Please confirm the address for <strong>{{companyName}}</strong>. It will be used to identify the' +
        ' corresponding legal entity for your SAP Store account.',
      createNew1: 'This information is defined by your company domain administrators.',
      createNew2: 'Don\'t see your company? Please check with the super administrator or ',
      createNew3: 'create new.'
    },
    placeholder: {
      countryCode: 'Country',
      company: 'Company/Organization Name',
      street: 'Address',
      addressLine2: 'Address Line 2 (Optional)',
      city: 'City',
      regionCode: 'State',
      postalCode: 'Postal Code',
      lineOfBusiness: 'Industry',
    },
    company: {
      loading: 'Please wait. We are preparing your account information.',
    },
    label: {
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      email: 'Email *',
      countryCode: 'Country *',
      company: 'Company/Organization Name *',
      department: 'Department *',
      street: 'Address *',
      addressLine2: 'Address Line 2 (Optional)',
      city: 'City *',
      regionCode: 'State *',
      postalCode: 'Postal Code *',
      lineOfBusiness: 'Industry *',
      companyDetails: 'Unternehmensdetails hinzufügen',
      selectionAlert: 'Es ist derzeit kein Unternehmen oder keine Organisation mit Ihrem Konto verbunden.',
      selectionTips: 'Das Hinzufügen einer Organisation hilft uns festzustellen, ob Ihre Organisation bereits bestehende Verträge hat, die diesen Kauf beeinflussen könnten.',
      returnBtn: 'Zurück zur Produktseite',
    },
    tooltip: {
      company: 'Please use the name of the company or organization for which you work.',
      street: 'Please provide the registered address of the company on whose behalf you are acting. This information will be used to identify the correct legal entity for contractual purposes and determine applicable taxes.',
    },
    error: {
      required: 'This field is mandatory.',
      nonLatin: 'Darf nur lateinische Zeichen enthalten.',
      oneLetter: 'Muss mindestens einen Buchstaben enthalten.',
      maxLength: 'Muss weniger als {{maxLength}} Zeichen umfassen.',
      email: 'Die E-Mail-Adresse muss ein gültiges Format haben (example@domain.com).',
      sameDomain: 'Unexpected e-mail domain.',
      regExpPostalCode: 'This field is invalid Postal Code.',
      forbiddenWords: 'Dieses Feld enthält ungültige Wörter.',
      duplicatesAddressOrCity: 'This field is the same as Address or City.',
      duplicatesAddressOrAddressLine2: 'This field is the same as Address or Address Line 2.',
      duplicatesAddressLine2: 'This field is the same as Address Line 2.',
      duplicatesCompany: 'This field is the same as Company/Organization Name',
      duplicatesAddress: 'This field is the same as Address',
      duplicatesNames: 'Must not be the same as first name',
      duplicatesNames2: 'Must not be the same as last name',
      duplicatesCity: 'This field is the same as City',
      somethingWrong: 'Something went wrong',
      validation: 'Please check the information you provided and try again. If the problem persists, don’t hesitate to contact us.',
      generic: 'It seems there’s been an issue with our system. Please try again later. If the problem persists, don’t hesitate to contact us.',
      previouslyRegisteredNonLatinName: 'Sie haben sich zuvor als <strong>{{firstName}} {{lastName}}</strong> bei SAP registriert. Um ein Konto im SAP Store zu registrieren, geben Sie bitte die englische Schreibweise Ihres Namens an.',
      previouslyRegisteredTooLongName: 'Sie haben sich zuvor als <strong>{{firstName}} {{lastName}}</strong> bei SAP registriert. Um ein Konto im SAP Store zu registrieren, geben Sie bitte einen gekürzten Namen mit weniger als 40 Zeichen an.',
      previouslyRegisteredForbiddenWords: 'Sie haben sich zuvor als <strong>{{firstName}} {{lastName}}</strong> bei SAP registriert. Um ein Konto im SAP Store zu registrieren, geben Sie bitte einen Namen ohne verbotene Wörter an.',
      noError: ''
    },
    info: 'We use this information for billing purposes. Accurate information will\n help us to process your order efficiently.',
    creditCardRestriction: {
      individualPurchaseNotAvailableHtml: 'Thank you for your interest! This solution isn’t available for individual purchase in your country/region, but your company or organization can still purchase it.',
    },
  },
};
